import { useState, useEffect, useContext } from "react";
import Category from "../category/Category";
import Company from "../company/Company";
import Units from "../units/Units";
import Years from "../year/Year";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import Context from "../../context/Context";

export default function FinancialEntries() {
    const { setPageTitle } = useContext(Context);
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const tabs = ["Companies", "Categories", "Units", "Time Period"];

    useEffect(() => {
        setPageTitle("Financial Data Entries");
    }, [setPageTitle]);

    const [activeTab, setActiveTab] = useState(() => {
        const tabFromUrl = searchParams.get("tab");
        return tabs.includes(tabFromUrl) ? tabFromUrl : "Companies";
    });

    const [filters, setFilters] = useState({});

    useEffect(() => {
        const { searchQuery } = location.state || {};
        if (searchQuery) {
            // Note: The tabFromUrl might not be present if directly navigating from global search,
            // so we might need to infer it or rely on default. For now, assume it's set in the Link path.
            const tabFromUrl = searchParams.get("tab");
            if (tabFromUrl) {
                setActiveTab(tabFromUrl);
            }
            setFilters({ search: searchQuery });
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, navigate, searchParams]);

    const handleTabClick = (tab) => {
        const params = new URLSearchParams(searchParams);
        params.set("tab", tab);
        if (params.has("p")) {
            params.delete("p");
        }
        setSearchParams(params, { replace: true });
        setActiveTab(tab);
        setFilters({}); // Clear filters when changing tabs
    };

    const renderComponent = (Component) => (
        <Component
            filters={filters}
            setFilters={setFilters}
            disableTitleUpdate={true}
        />
    );

    return (
        <div className="mt-2">
            <div className="px-4 pb-1 mb-2 flex flex-col sm:flex-row items-start sm:items-center justify-end gap-3">
                {/* <h2 className="text-2xl font-semibold flex">Financial Data Entries</h2> */}

                <div className="flex gap-1 rounded-[5px] bg-[#F6F6F6] p-1 w-full sm:w-auto overflow-x-auto">
                    {tabs.map((tab, index) => (
                        <button
                            key={tab}
                            onClick={() => handleTabClick(tab)}
                            className={`px-[16px] sm:px-4 py-[9px] text-[16px] !font-normal rounded-[5px] sm:text-sm font-medium whitespace-nowrap flex-shrink-0
                ${index === 0 ? "rounded-l-md" : ""} 
                ${index === tabs.length - 1 ? "rounded-r-md" : ""} 
                ${activeTab === tab
                                    ? "bg-white text-gray-800"
                                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                                }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
            </div>
            <div className="border-b mr-6 ml-6 mt-[-5px]"></div>

            <div>
                {activeTab === "Companies" && renderComponent(Company)}
                {activeTab === "Categories" && renderComponent(Category)}
                {activeTab === "Units" && renderComponent(Units)}
                {activeTab === "Time Period" && renderComponent(Years)}
            </div>
        </div>
    );
}